import * as en_US from './en_US.json';
import * as fr_FR from './fr_FR.json';
import * as de_DE from './de_DE.json';
export const localeText = { en_US,fr_FR,de_DE};
  